import React from 'react'
import styles from './DataTable.css'
import {LABEL_STATUS_REQUEST} from '../constants/constants'
import {
    ModalTrigger,
    ModalCommentClient,
} from './Modales.jsx'

export const TableServices = ({services, totalNeto, iva, total}) => {
    return (
        <div className="table-responsive">
            <table className={`table table-striped ${styles.DataTable}`}>
                <thead>
                <tr>
                    <th>Fecha Servicio</th>
                    <th>Cliente</th>
                    <th>CECO</th>
                    <th className={styles.DataTable_thNameStore}>Local</th>
                    <th>Región</th>
                    <th>Comuna</th>
                    <th>Und Contadas</th>
                    <th>Valor Unidad</th>
                    <th>Total</th>
                    <th>Solicitud</th>
                    <th className={styles.DataTable_thCommentClient}></th>
                </tr>
                </thead>
                <tbody>
                {services.map((service)=>
                    <tr key={service.service_id}>
                        <td>{service.service_date}</td>
                        <td className={styles.DataTable_tdNameClient}>{service.client_name}</td>
                        <td className={styles.DataTable_tdCeco}>{service.store_ceco}</td>
                        <td className={styles.DataTable_tdNameStore}>{service.store_name}</td>
                        <td>{service.store_region}</td>
                        <td>{service.store_comuna}</td>
                        <td className={styles.DataTable_tdTotalService}>{service.units_counted.toLocaleString("es-CL")}</td>
                        <td className={styles.DataTable_tdTotalService}>{"$"+service.unit_value}</td>
                        <td className={styles.DataTable_tdTotalService}>{service.total_billing.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                        <td>
                            {service.pub_billing_req_id?
                                <ButtonRequestBilling
                                    publicIdBillingRequest={service.pub_billing_req_id}
                                    number={service.billing_request_num} 
                                    className={LABEL_STATUS_REQUEST[service.billing_request_status]}
                                />
                                :
                                <a className="btn btn-xs btn-warning">
                                    No Enviada
                                </a>
                            }
                        </td>
                        <td>
                            {service.client_comment === ''?
                                null:
                                <ButtonCommentClient
                                    service={service}
                                />
                            }
                        </td>
                    </tr>
                )}
                <tr className="success">
                    <td colSpan="7"></td>
                    <td className={styles.DataTable_tdFinalTotalsText}>Neto Aprobado</td>
                    <td className={styles.DataTable_tdFinalTotals}>{totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                    <td colSpan="2"></td>
                </tr>
                <tr className="success">
                    <td colSpan="7"></td>
                    <td className={styles.DataTable_tdFinalTotalsText}>IVA Aprobado</td>
                    <td className={styles.DataTable_tdFinalTotals}>{iva.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                    <td colSpan="2"></td>
                </tr>
                <tr className="success">
                    <td colSpan="7"></td>
                    <td className={styles.DataTable_tdFinalTotalsText}>Total Aprobado</td>
                    <td className={styles.DataTable_tdFinalTotals}>{total.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                    <td colSpan="2"></td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}
const ButtonRequestBilling = ({publicIdBillingRequest, number, className}) => {
    return (
        <a className={`btn btn-xs ${className}`} href={`/billing/oc/management?id_billing_request=${publicIdBillingRequest}`} target="_blank">{number}</a>
    )
}
const ButtonCommentClient = ({service}) => {
    return (
        <ModalTrigger>
            {(isVisible, showModal, hideModal) =>
                <button
                    className="btn btn-warning"
                    onClick={showModal}
                >
                    <span className="glyphicon glyphicon-inbox"></span>
                    {isVisible &&
                    <ModalCommentClient
                        service={service}
                        hideModal={hideModal}
                    />
                    }
                </button>
            }
        </ModalTrigger>
    )
}



// WEBPACK FOOTER //
// ./frontEnd/billing/billing-services/DataTable.jsx